import App from '../client/pages/app'
import HomePage from '../client/pages/home/homePage'
import LandingPage from '../client/pages/landing/landingPage'
import NotFoundPage from '../client/pages/notFoundPage'
import SearchPage from '../client/pages/search/searchPage'

import createAppContainer from '../client/containers/appContainer'
import createHomePageContainer from '../client/containers/homePageContainer'
import createLandingPageContainer from '../client/containers/landingPageContainer'
import createNotFoundContainer from '../client/containers/notFoundContainer'
import createSearchPageContainer from '../client/containers/searchPageContainer'

import { RouteConfig } from 'react-router-config'

/* tslint:disable */
// TODO: Get this merged in the upstream react-router-config DefinitelyTyped file
declare module 'react-router-config' {
  export interface RouteConfig {
    key?: string
  }
}
/* tslint:enable */

const routeConfig: RouteConfig[] = [
  {
    component: createAppContainer(App),
    path: '/',
    routes: [
      {
        component: createHomePageContainer(HomePage),
        exact: true,
        path: '/'
      },
      {
        component: createSearchPageContainer(SearchPage),
        key: 'search',
        path: '/category/*'
      },
      {
        component: createSearchPageContainer(SearchPage),
        key: 'search',
        path: '/tags/:tags'
      },
      {
        component: createSearchPageContainer(SearchPage),
        key: 'search',
        path: '/attributes/:key/:value'
      },
      {
        component: createSearchPageContainer(SearchPage),
        key: 'search',
        path: '/search'
      },
      {
        component: createLandingPageContainer(LandingPage),
        path: '/free/:page'
      },
      {
        component: createNotFoundContainer(NotFoundPage),
        path: '/*'
      }
    ]
  }
]

export default routeConfig



// WEBPACK FOOTER //
// ./common/routes.v0.ts